export const MASCOT_URL = process.env.REACT_APP_MASCOT_URL;

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const mediaUrl = (path) => `${BACKEND_URL}${path}`;
